import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormGroupDirective,
} from '@angular/forms';
import {
  Errors,
  LocalService,
  ManagerService,
  SellerService,
} from 'src/app/core';
import { CONSTANTS } from 'src/app/config';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';

@Component({
  selector: 'app-claim-by-po',
  templateUrl: './claim-by-po.component.html',
  styleUrls: ['./claim-by-po.component.scss'],
})
export class ClaimByPoComponent implements OnInit {
  @ViewChild(FormGroupDirective) myForm: any;

  claimForm!: FormGroup;
  errMessages: any = CONSTANTS.errMessages;
  errors: Errors = { errors: {} };
  userProfile: any;

  poSearchModalOpen = false;
  poSearchResult: any = null;
  poSearchInputValue: string = '';

  confirmModalOpen = false;

  constructor(
    private formBuilder: FormBuilder,
    private sellerService: SellerService,
    private managerService: ManagerService,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnInit() {
    const lang = localStorage.getItem('selectedLanguage');
    if (lang === 'Korean') {
      this.errMessages = CONSTANTS.korean_errMessages;
    }
    if (lang === 'Japanese') {
      this.errMessages = CONSTANTS.japanese_errMessages;
    }

    this.userProfile = LocalService.get('userProfile');
    this.generateForm();
  }

  generateForm() {
    this.claimForm = this.formBuilder.group({
      poNumber: ['', [Validators.required]],
    }) as FormGroup;
  }

  getPoNumberError(): string {
    if (!this.claimForm) {
      return '';
    }
    const ctrl = this.claimForm.get('poNumber');
    if (!ctrl || !ctrl.touched) {
      return '';
    }
    for (const err of this.errMessages.poNumber) {
      if (ctrl.hasError(err.type)) {
        return err.message;
      }
    }
    return '';
  }

  hasPoNumberError(): boolean {
    return this.getPoNumberError() !== '';
  }

  onSearchPoStatus() {
    const ctrl = this.claimForm.get('poNumber');
    this.sellerNoRecorFound(ctrl ? ctrl.value : '');
  }

  sellerNoRecorFound(searchText: string): void {
    this.poSearchInputValue = searchText || '';
    this.poSearchModalOpen = true;
    const queryParam = {
      searchText: searchText,
      companyId: this.userProfile.company.id,
    };
    this.managerService.getpoSearchResult(queryParam).subscribe(
      (data: any) => {
        this.poSearchResult = data || { found: false, searchText: searchText };
      },
      (err: any) => {
        this.errors = err;
        this.poSearchResult = { found: false, searchText: searchText };
      }
    );
  }

  searchPoAgain(): void {
    this.sellerNoRecorFound(this.poSearchInputValue);
  }

  closePoSearchModal(): void {
    this.poSearchModalOpen = false;
    this.poSearchResult = null;
    this.poSearchInputValue = '';
  }

  claimDealByPo(): void {
    this.confirmModalOpen = true;
  }

  onClaimByPoConfirm(): void {
    this.confirmModalOpen = false;
    const lang = localStorage.getItem('selectedLanguage');
    const reqParam = 'poNumber=' + this.claimForm.value.poNumber;
    this.sellerService.claimByPoSeller(reqParam).subscribe(
      (data: any) => {
        let msg = 'Deal claimed successfully.';
        if (lang === 'Korean') {
          msg = '거래가 성공적으로 청구되었습니다.';
        }
        if (lang === 'Japanese') {
          msg = '取引が正常に請求されました。';
        }
        this.popupMessageService.showSuccess(msg, 'success', 'claimbyPo');
        this.claimForm.reset();
        if (this.myForm) {
          this.myForm.resetForm();
        }
      },
      (err: any) => {
        if (err.message) {
          this.popupMessageService.showError(err.message, 'error');
        }
        this.errors = err;
      }
    );
  }

  closeClaimByPoConfirm(): void {
    this.confirmModalOpen = false;
  }
}
